import React from 'react';
import { Row, Col } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import AnalyticsCard from '../../components/shared/AnalyticsCard';
import ChartContainer from '../../components/shared/ChartContainer';
import { mockClientAnalyticsData, mockAcquisitionTrend } from '../data/mockData';

const AcquisitionChart: React.FC = () => {
  const { acquisition } = mockClientAnalyticsData;

  // Prepare chart data for acquisition trend
  const acquisitionChartData = {
    labels: mockAcquisitionTrend.map(item => item.month),
    datasets: [
      {
        label: 'Acquired Clients',
        data: mockAcquisitionTrend.map(item => item.acquired),
        borderColor: '#1890ff',
        backgroundColor: 'rgba(24, 144, 255, 0.1)',
        fill: true,
      },
      {
        label: 'Target',
        data: mockAcquisitionTrend.map(item => item.target),
        borderColor: '#52c41a',
        backgroundColor: 'rgba(82, 196, 26, 0.1)',
        borderDash: [5, 5],
        fill: false,
      },
    ],
  };

  const conversionChartData = {
    labels: mockAcquisitionTrend.map(item => item.month),
    datasets: [
      {
        label: 'Lead Conversion Rate (%)',
        data: mockAcquisitionTrend.map(item => item.leadConversion),
        borderColor: '#722ed1',
        backgroundColor: 'rgba(114, 46, 209, 0.1)',
        fill: true,
      },
    ],
  };

  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <AnalyticsCard
            title="Total Acquired"
            value={acquisition.totalAcquired}
            format="number"
            trend="up"
            change={12.3}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Acquisition Rate"
            value={acquisition.acquisitionRate}
            format="percentage"
            trend="up"
            change={2.1}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Lead Conversion"
            value={acquisition.leadConversion}
            format="percentage"
            trend="up"
            change={1.8}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Marketing Effectiveness"
            value={acquisition.marketingEffectiveness}
            format="percentage"
            trend="stable"
            change={0.3}
            subtitle="vs last month"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <ChartContainer
            title={
              <span>
                <UserAddOutlined /> Client Acquisition Trend
              </span>
            }
            type="area"
            data={acquisitionChartData}
            height={300}
          />
        </Col>
        <Col span={12}>
          <ChartContainer
            title="Lead Conversion Rate Trend"
            type="line"
            data={conversionChartData}
            height={300}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AcquisitionChart; 